import { useRecoilState } from 'recoil'
import clsx from 'clsx'
import BigNumber from 'bignumber.js'
import IconToken from '@/components/icons/IconToken'
import IconSwitchArrow from '@/components/icons/IconSwitchArrow'
import numberFormat from '@/utils/numberFormat'
import { showWalletBalanceState } from '@/recoil/Wallet'
import { TOKEN_NAME_MAP } from '@/constants/token'
import './AssetBalance.css'

const HIDDEN_NUMBER = '******'

export default function AssetBalance({
  symbol,
  balance = 0,
  available = 0,
  valueInUsdc = 0,
  isDeFiWallet = false,
  showAssetDetailInfo,
  toggleShowAssetDetail = () => {}
}) {
  const [showWalletBalance] = useRecoilState(showWalletBalanceState)
  const availableBalance = isDeFiWallet ? balance : available
  return (
    <div
      className={clsx('asset-balance-card', {
        'is-flipped': showAssetDetailInfo
      })}
    >
      <div className={clsx('asset-balance', { 'defi-wallet': isDeFiWallet })}>
        <div className="asset-info-row">
          <div className="token-label">
            <IconToken className="token-icon" symbol={symbol} />
            {symbol}
          </div>
          <div>
            {showWalletBalance
              ? numberFormat(availableBalance, 'max8')
              : HIDDEN_NUMBER}
          </div>
        </div>
        <div className="asset-info-row">
          {isDeFiWallet ? (
            <div className="token-name">{TOKEN_NAME_MAP[symbol]}</div>
          ) : (
            <div className="token-name-wrap">
              <div
                className="toggle-asset-detail-button"
                onClick={toggleShowAssetDetail}
              >
                <IconSwitchArrow />
              </div>
              <div className="token-name">{TOKEN_NAME_MAP[symbol]}</div>
            </div>
          )}
          <div>
            {showWalletBalance ? numberFormat(valueInUsdc, 2) : HIDDEN_NUMBER}{' '}
            USDC
          </div>
        </div>
      </div>
      {!isDeFiWallet && (
        <div className="asset-balance asset-balance-detail">
          <div className="token-column-wrap">
            <IconToken className="token-icon" symbol={symbol} />
            <div
              className="toggle-asset-detail-button"
              onClick={toggleShowAssetDetail}
            >
              <IconSwitchArrow />
            </div>
          </div>
          <div className="asset-detail-info">
            <div className="detail-info-row">
              <span className="detail-info-label">Available</span>
              {showWalletBalance
                ? numberFormat(available, 'max8')
                : HIDDEN_NUMBER}
            </div>
            <div className="detail-info-row">
              <span className="detail-info-label">In use</span>
              {showWalletBalance
                ? numberFormat(
                    BigNumber(balance).minus(available).toNumber(),
                    'max8'
                  )
                : HIDDEN_NUMBER}
            </div>
            <div className="detail-info-row">
              <span className="detail-info-label">Balance</span>
              {showWalletBalance
                ? numberFormat(balance, 'max8')
                : HIDDEN_NUMBER}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
